<template>
  <section class="contact-page">
    <h1 class="page-title">Fale Conosco</h1>
    <div class="contact-container">
      <!-- Informações da empresa -->
      <div class="contact-info">
        <h2>Informações de Contato</h2>
        <p><strong>Endereço:</strong> Rua Guiné Bissau, Lobito - Angola</p>
        <p><strong>Telefone:</strong> <a href="tel:+244922488863">922 488 863</a></p>
        <p><strong>Email:</strong> <a href="mailto:contacto@ffjb.ao">contacto@ffjb.ao</a></p>
        <p><strong>Horário de Atendimento:</strong></p>
        <ul>
          <li>Segunda à Sábado: 08h - 17h</li>
          <li>Online: 24h / 7</li>
        </ul>
        <h3>Siga-nos</h3>
        <div class="social-icons">
          <a href="https://www.facebook.com/profile.php?id=61557384655175" target="_blank"><font-awesome-icon icon="fa-brands fa-facebook" /></a>
          <a href="https://instagram.com/ffjb" target="_blank"><font-awesome-icon icon="fa-brands fa-instagram" /></a>
          <a href="https://linkedin.com/ffjb" target="_blank"><font-awesome-icon icon="fa-brands fa-linkedin" /></a>
          <a href="https://wa.me/244912345678" target="_blank"><font-awesome-icon icon="fa-brands fa-whatsapp" /></a>
        </div>
      </div>

      <!-- Formulário de contato -->
      <div class="contact-form">
        <h2>Envie uma Mensagem</h2>
        <form @submit.prevent="enviarWhatsApp">
          <input v-model="form.nome" type="text" placeholder="Seu Nome" required />
          <input v-model="form.email" type="email" placeholder="Seu Email" required />
          <input v-model="form.telefone" type="tel" placeholder="Seu Telefone" required />
          <input v-model="form.assunto" type="text" placeholder="Assunto" required />
          <textarea v-model="form.mensagem" rows="5" placeholder="Sua Mensagem" required></textarea>
          <button type="submit">Enviar via WhatsApp</button>
        </form>
      </div>
    </div>

    <!-- Mapa -->
    <div class="map-container">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m17!1m8!1m3!1d1417.4816992531216!2d13.544671948841787!3d-12.382345180193921!3m2!1i1024!2i768!4f13.1!4m6!3e6!4m0!4m3!3m2!1d-12.382423319713563!2d13.54531975755355!5e0!3m2!1spt-PT!2sao!4v1747939981907!5m2!1spt-PT!2sao"
        width="100%"
        height="350"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
      ></iframe>
    </div>
  </section>
</template>

<script setup>
import { reactive } from 'vue'

const form = reactive({
  nome: '',
  email: '',
  telefone: '',
  assunto: '',
  mensagem: '',
})

const enviarWhatsApp = () => {
  const numero = '244922488863'
  const mensagem = `Olá, sou ${form.nome} 
Email: ${form.email} 
Telefone: ${form.telefone} 
Assunto: ${form.assunto} 
Mensagem: ${form.mensagem}`

  const url = `https://wa.me/${numero}?text=${encodeURIComponent(mensagem)}`
  window.open(url, '_blank')
}
</script>

<style scoped>
.contact-page {
  padding: 2rem;
  background: linear-gradient(to right, #003366, #0055aa);
  font-family: 'Segoe UI', sans-serif;
  color: #000;
}

.page-title {
  text-align: center;
  color: #fff;
  margin-bottom: 2rem;
  font-size: 2.5rem;
  font-weight: bold;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
}

.contact-container {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
  align-items: flex-start;
  transition: all 0.4s ease-in-out;
}

.contact-info
{
  flex: 1 1 400px;
  background: linear-gradient(135deg, #f5f9ff, #e6f0fa);
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.contact-form {
  flex: 1 1 400px;
  background: linear-gradient(135deg, #f5f9ff, #e6f0fa);
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

h2 {
text-align: center;
}
.contact-info:hover,
.contact-form:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);
}

.contact-info h2,
.contact-form h2 {
  color: #003366;
  margin-bottom: 1rem;
}

.contact-info a {
  color: #003366;
  text-decoration: none;
}

.contact-info ul {
  list-style: none;
  padding-left: 0;
  margin: 0.5rem 0;
}

.social-media {
  margin-top: 1rem;
}

.social-icons {
  display: flex;
  gap: 15px;
  font-size: 22px;
}

 .social-icons a:hover {
  text-decoration: underline;
  color: #0fdf8a;
}
.social-media a {
  margin-right: 1rem;
  font-size: 1.5rem;
  color: #0055aa;
  transition: color 0.3s ease;
}

.social-media a:hover {
  color: #003366;
}

.contact-form form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.contact-form input,
.contact-form textarea {
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  transition: border 0.3s ease;
}

.contact-form input:focus,
.contact-form textarea:focus {
  outline: none;
  border-color: #0055aa;
}

.contact-form button {
  padding: 0.75rem;
  background-color: #0055aa;
  color: #fff;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.contact-form button:hover {
  background-color: #003366;
}

.map-container {
  margin-top: 2rem;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
}

/* Responsivo */
@media (max-width: 768px) {
  .contact-container {
    flex-direction: column;
  }

  .contact-info,
  .contact-form {
    width: 100%;
  }
}
</style>

<!-- SEO -->
<script>
export default {
  name: "ContactoPage",
  metaInfo: {
    title: "Fale Conosco | ERGAB",
    meta: [
      {
        name: "description",
        content:
          "Entre em contato com a ERGAB. Endereço, WhatsApp, e-mail e formulário de contato. Suporte completo para sua empresa 24h/7."
      },
      {
        name: "keywords",
        content:
          "contato, suporte técnico, ERGAB, Lobito, WhatsApp, email, localização, horário, formulário"
      },
      {
        name: "robots",
        content: "index, follow"
      },
      {
        name: "author",
        content: "ERGAB"
      },
      {
        property: "og:title",
        content: "Fale Conosco | ERGAB"
      },
      {
        property: "og:description",
        content: "Precisa de ajuda? Entre em contato com a equipe ERGAB agora mesmo."
      },
      {
        property: "og:type",
        content: "website"
      }
    ]
  }
}
</script>
